<script setup lang="ts">
/**
 * The late-payment banner, above every screen of those who read billing: an
 * invoice unpaid past its due date, what is left, and the day billing
 * suspends the company.
 */
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useFormat } from '@/lib/format'
import Banner from '@/ui/Banner.vue'
import { useCompanyBilling } from './billing'

const { t } = useI18n()
const f = useFormat()
const route = useRoute()
const billing = useCompanyBilling()
const overdue = computed(() => billing.data.value?.overdue ?? null)
</script>

<template>
  <div v-if="overdue && route.path !== '/billing'" class="px-6 pt-3 max-sm:px-4">
    <Banner :tone="overdue.pastGrace ? 'danger' : 'warning'">
      {{ t('billing.late', { number: overdue.number, left: f.money(overdue.left, overdue.currency), date: f.date(overdue.suspendOn) }) }}
      <RouterLink to="/billing" class="ms-1 font-medium underline">{{ t('billing.lateLink') }}</RouterLink>
    </Banner>
  </div>
</template>
